import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';


const BASE_URL = "http://localhost:3000/items"; 
const BASE_URL2 = "http://localhost:3000/item-category"; 
const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})

export class ItemService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }



   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/items`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    addItem(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/items`,  data)
        .pipe(catchError(this.handleError));
       
    }


    updateItem(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/items`, data)
        .pipe(catchError(this.handleError));
       
    }

    deleteItem(itemCode: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/items/${itemCode}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    ///////// Item Category

    getAllItemCategory():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/item-category`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

      addItemCategory(data):Observable <any>{
        return this.http.post<any>(`${this.env.apiUrl}/item-category`,  data ,httpOptions)
          .pipe(catchError(this.handleError));
         
      }
     
  
      deleteItemCategory(id: number) : Observable <void>{
        return this.http.delete<void>(`${this.env.apiUrl}/item-category/${id}`,httpOptions)
          .pipe(catchError(this.handleError));
         
      }


        ///////// Item Category

    getAllStockBal():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/stock-balance`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

      getAllMatStockBal():Observable <any[]> {
        return this.http.get<any[]>(`${this.env.apiUrl}/material-balance`,httpOptions)
        .pipe(catchError(this.handleError));
           
        }

    private handleError(errorResponse: HttpErrorResponse) {
      // if(errorResponse.error instanceof ErrorEvent){
      //   console.error('Client side error',errorResponse.error.message);
      // }    
      // else{
      //   console.error('Server side error',errorResponse.message);
      // }
    
      return throwError(errorResponse || "Server Error");

      }


}
